// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1bt2l","infoBtn":"quickbooks_infoBtn__1GCTj","formBox":"quickbooks_formBox__i1m_j","formFooter":"quickbooks_formFooter__dxI9x"};